module.exports = __webpack_public_path__ + "img/primary_7x2_z16.934cf601.svg";